import React, { useState } from "react";

const ApplicationProcedureYTS = () => {
  const [activeSection, setActiveSection] = useState(null);

  const handleToggle = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const sections = [
    {
      id: 1,
      title: "Application Procedure",
      content: `1. Complete the online application form available on our website.

2. Submit a copy of your high school diploma or equivalent qualification.

3. Provide a brief statement of propppose outlining your interest in the course & how it aligns with your academic & professional goals.

4. If available, submit any additional documents or certificates relevant to your application.

5. Await confirmation of acceptance from the admissions committee.`,
    },
    {
      id: 2,
      title: "Programme Cost",
      content: `The course fee for the Young Emerging Trade Specialist course is $350. Please note that this fee covers tuition only & does not include additional expenses such as textbooks or accommodation. Financial aid options may be available for eligible candidates. For detailed information on fees & payment procedures, please refer to the official website or contact our admissions office.`,
    },
  ];

  return (
    <div
      className="md:scroll-mt-44 scroll-mt-16 my-10"
      id="application-procedure"
    >
      <div className="bg-gradient-to-r from-gray-600 to-blue-950 py-10">
        <div className="max-w-6xl mx-auto px-10 space-y-8">
          <h2 className="text-2xl font-extrabold text-center mb-6 text-white">
            Application Procedure & Programme Cost
          </h2>
          <div className="bg-sdbodywhite h-1 w-20 mx-auto rounded"></div>
          <div className="space-y-4">
            {sections.map((section) => (
              <div
                key={section.id}
                className="border border-gray-300 rounded-lg overflow-hidden shadow-lg"
              >
                <button
                  onClick={() => handleToggle(section.id)}
                  className="w-full text-left py-4 px-5 bg-blue-100 hover:bg-blue-200 focus:outline-none"
                >
                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-lg text-gray-700">
                      {section.title}
                    </span>
                    <span className="text-gray-600">
                      {activeSection === section.id ? "▲" : "▼"}
                    </span>
                  </div>
                </button>
                {activeSection === section.id && (
                  <div className="px-5 py-4 bg-sdbodywhite">
                    <p className="text-gray-800 leading-relaxed whitespace-pre-line">
                      {section.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationProcedureYTS;
